import { render, staticRenderFns } from "./SampleOpinion.vue?vue&type=template&id=3af2d4f1&scoped=true&"
import script from "./SampleOpinion.vue?vue&type=script&lang=js&"
export * from "./SampleOpinion.vue?vue&type=script&lang=js&"
import style0 from "./SampleOpinion.vue?vue&type=style&index=0&id=3af2d4f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af2d4f1",
  null
  
)

export default component.exports